import React, { memo, useContext, useReducer } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { AppBar, Box, Tab, Tabs } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { context } from '../../../../../globalState/GlobalState';
import { getOptimXBackgroundStyle } from '../../../../../catalog/Website';
import Player1TextTab from './Player1TextTab';
import { isValidObject, isValidString } from '../../../../../catalog/Validity';
import ArticlesComponent3 from '../../../../uiElements/articlesComponents/articlesComponent3/ArticlesComponent3';
import GalleriesComponent3 from '../../../../uiElements/galleriesComponents/galleriesComponent3/GalleriesComponent3';
import Player1IceHockeyStatsTab from './statsTabs/Player1IceHockeyStatsTab';
import Player1RugbyStatsTab from './statsTabs/Player1RugbyStatsTab';
import Player1IceHockeyGameLogsTab from './gameLogsTabs/Player1IceHockeyGameLogsTab';
import ImagesComponent1 from '../../../../uiElements/imagesComponents/imagesComponent1/ImagesComponent1';
import { SportsType } from '../../../../../catalog/enums/SportsType';
import Player1RugbyGameLogsTab from './gameLogsTabs/Player1RugbyGameLogsTab';
import Player1LacrosseGameLogsTab from './gameLogsTabs/Player1LacrosseGameLogsTab';
import Player1LacrosseStatsTab from './statsTabs/Player1LacrosseStatsTab';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            className="bg-white box-shadow-black curve-border-20px"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node.isRequired,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const AntTabs = withStyles({
    indicator: {
        backgroundColor: 'black',
    },
})(Tabs);

const initialState = {
    tabIndex: 0,
};

function reducer(state, action) {
    switch (action.type) {
        case 'setTabIndex':
            return { ...state, tabIndex: action.tabIndex };
        default:
            return initialState;
    }
}

const Player1Tabs = (props) => {
    const params = useParams();
    const { bio, texts, teamNumber, position, stats, gameLogs } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);

    const getTeamNumberPositionBadge = () => {
        return (
            <div className="player1-tab-badge-container m-l-100px m-t-50px m-b-50px">
                <div className="player1-tab-badge-content curve-border-5px m-r-10px box-shadow-black">
                    <p className="m-t-0 m-b-0 p-l-10px p-r-10px p-t-5px p-b-5px condensed-font-family" style={getOptimXBackgroundStyle(globalState)}>{teamNumber}</p>
                    <p className="m-t-0 m-b-0 p-l-10px p-r-10px p-t-5px p-b-5px player1-tab-badge-text text-black condensed-font-family">{position}</p>
                </div>
                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (<img className="player1-tab-badge-logo m-l-10px" src={globalState.logo.logo2} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />) : null}
            </div>
        );
    };

    const getGameLogs = () => {
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return (<Player1IceHockeyGameLogsTab isGoalie={position === 'Goalie'} gameLogs={gameLogs} />);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return (<Player1RugbyGameLogsTab gameLogs={gameLogs} />);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return (<Player1LacrosseGameLogsTab isGoalie={position === 'Goalie'} gameLogs={gameLogs} />);
        }
        return null;
    };

    const getStats = () => {
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return (<Player1IceHockeyStatsTab isGoalie={position === 'Goalie'} stats={stats} />);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return (<Player1RugbyStatsTab stats={stats} />);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return (<Player1LacrosseStatsTab isGoalie={position === 'Goalie'} stats={stats} />);
        }
        return null;
    };

    return (
        <div className="player1-tabs-container x-center m-t-20px">
            <AppBar position="static" style={{ backgroundColor: 'white', color: 'black', boxShadow: 'none', height: 'auto', paddingBottom: '20px' }}>
                <AntTabs
                    value={state.tabIndex}
                    onChange={(event, newValue) => { setState({ type: 'setTabIndex', tabIndex: newValue }); }}
                    aria-label="player tabs"
                    scrollButtons="on"
                    variant="scrollable"
                >
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Bio" />
                    {texts.map((text) => {
                        return (
                            <Tab className="condensed-font-family font-spacing-wide font-size-m" key={text.title} label={text.title} />
                        );
                    })}
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Stats" />
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Game Logs" />
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Articles" />
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Images" />
                    <Tab className="condensed-font-family font-spacing-wide font-size-m" label="Galleries" />
                </AntTabs>
            </AppBar>
            <TabPanel value={state.tabIndex} index={0}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Bio</p>
                <Player1TextTab title="Bio" text={bio} />
                {getTeamNumberPositionBadge()}
            </TabPanel>
            {texts.map((text, index) => {
                return (
                    <TabPanel key={text.value} value={state.tabIndex} index={index + 1}>
                        <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">{text.title}</p>
                        <Player1TextTab title={text.title} text={text.value} />
                        {getTeamNumberPositionBadge()}
                    </TabPanel>
                );
            })}
            <TabPanel value={state.tabIndex} index={texts.length + 1}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Stats</p>
                {getStats()}
                {getTeamNumberPositionBadge()}
            </TabPanel>
            <TabPanel value={state.tabIndex} index={texts.length + 2}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Game Logs</p>
                {getGameLogs()}
                {getTeamNumberPositionBadge()}
            </TabPanel>
            <TabPanel value={state.tabIndex} index={texts.length + 3}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Articles</p>
                <ArticlesComponent3 tagId={params.playerid} showTitle={false} />
                {getTeamNumberPositionBadge()}
            </TabPanel>
            <TabPanel value={state.tabIndex} index={texts.length + 4}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Images</p>
                <div className="player1-tabs-images">
                    <ImagesComponent1 tagId={params.playerid} />
                </div>
                {getTeamNumberPositionBadge()}
            </TabPanel>
            <TabPanel value={state.tabIndex} index={texts.length + 5}>
                <p className="player1-tabs-title font-size-4xl text-left-align condensed-font-family text-uppercase m-l-50px m-r-100px">Galleries</p>
                <GalleriesComponent3 tagId={params.playerid} showTitle={false} />
                {getTeamNumberPositionBadge()}
            </TabPanel>
        </div>
    );
};

Player1Tabs.propTypes = {
    bio: PropTypes.string.isRequired,
    texts: PropTypes.array.isRequired,
    teamNumber: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    stats: PropTypes.array.isRequired,
    gameLogs: PropTypes.array.isRequired,
};

export default memo(Player1Tabs);
